import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=653c9fd1&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=653c9fd1&prod&lang=css&"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=653c9fd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c9fd1",
  null
  
)

export default component.exports